export default __webpack_public_path__ + "static/media/truck_gray.71522b65.svg";